import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    overflow: 'hidden',
  },
  image: {
    objectFit: 'cover',
    width: '100%',
    height: '100%',
    maxWidth: '100% !important',
  },
  overlayImage: {
    position: 'absolute !important',
    height: '100%',
    width: '100%',
    // display: 'none',
    img: {
      objectFit: 'contain !important',
    },
    transform: 'translateX(3%)',
  },
};
